export class Call {
     
    private id: string; 
    private communicationId: string; 
    private callDate: Date; 
    private entityId: string; 
    private taskName: string; 
    private comment: string; 
    private callType: string; 
    private callLength: number; 
    private operatorName: string; 
    private pipelineId: number;
    private leadStage: number; 
    private statusId: number;
    private region: string; 
    private callLink: string; 
    private createdAt: Date; 
    private modifiedAt: Date;
    private triggerTypes: string[] = [];
    private triggerPhrases: string[] = [];

    constructor( id: string, communicationId: string, callDate: Date, entityId: string, taskName: string, comment: string, callType: string, callLength: number, operatorName: string, pipelineId: number, leadStage: number, statusId: number, region: string, callLink: string, createdAt: Date, modifiedAt: Date,) {
        this.id = id;
        this.communicationId = communicationId;
        this.callDate = callDate;
        this.entityId = entityId;
        this.taskName = taskName;
        this.comment = comment;
        this.callType = callType;
        this.callLength = callLength;
        this.operatorName = operatorName;
        this.pipelineId = pipelineId;
        this.leadStage = leadStage;
        this.statusId = statusId;
        this.region = region;
        this.callLink = callLink;
        this.createdAt = createdAt;
        this.modifiedAt = modifiedAt;
        
    }

    
    public Id = (): string => {
        return this.id
    }
    public CommunicationId = (): string => {
        return this.communicationId
    }
    public CallDate = (): Date => {
        return this.callDate
    }
    public EntityId = (): string => {
        return this.entityId
    }
    public TaskName = (): string => {
        return this.taskName
    }
    public Comment = (): string => {
        return this.comment
    }
    public CallType = (): string => {
        return this.callType
    }
    public CallLength = (): number => {
        return this.callLength
    }
    public OperatorName = (): string => {
        return this.operatorName
    }
    public PipelineId = (): number => {
        return this.pipelineId
    }
    public LeadStage = (): number => {
        return this.leadStage
    }
    public StatusId = (): number => {
        return this.statusId
    }
    public Region = (): string => {
        return this.region
    }
    public CallLink = (): string => {
        return this.callLink
    }
    public CreatedAt = (): Date => {
        return this.createdAt
    }
    public ModifiedAt = (): Date => {
        return this.modifiedAt
    }

    public SetTriggerData = (triggerTypes: string[], triggerPhrases: string[]) => {
        this.triggerTypes = [...triggerTypes]
        this.triggerPhrases = [...triggerPhrases]
    }

    public TriggerTypes = (): string[] => {
        return [...this.triggerTypes]
    }

    public TriggerPhrases = (): string[] => {
        return [...this.triggerPhrases]
    }
}
